import React, { useEffect } from "react";
import SectionWrapper from "Components/SectionWrapper/SectionWrapper.js";
import Kontakt from "Sections/SectionKontakt/Kontakt.js";
import "./LandingSection.css";

function ScrollLandingPage(props) {
  useEffect(() => {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  return null;
}

const LandingSection = () => (
  <div>
    <SectionWrapper title="Herzlich Willkommen">
      <ScrollLandingPage />
      <div className="landing_section_text">
        <p>
          <span>
            Sehr geehrte Patientinnen und Patienten, liebe Kolleginnen und
            Kollegen,
          </span>
          <br />
          Als fachübergreifende Gemeinschaftspraxis können wir für unsere Region das gesamte ambulante Spektrum der
          Gefäßmedizin anbieten.
          <br />
          Einzelheiten erfahren Sie auf den folgenden Seiten.
        </p>
      </div>
      <div
        className="landing_kbv_card"
      >
        <div className="landing_kbv_text">
          <p className="landing_kbv_label">Aktuelle Informationen</p>
          <h2>GKV-Spargesetz: Ambulante Versorgung in Gefahr</h2>
          <p>Informationen und Poster zum Herunterladen.</p>
          <div className="landing_kbv_links">
            <a
              href="/spargesetz-patienteninfo.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Patienteninfo
            </a>
            <a
              href="/spargesetz-poster-farbe.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Poster
            </a>
          </div>
        </div>
        <img
          src="/KBV_Stoerer_Praxennichtkaputtsparen_1080x1080.png"
          alt="Praxen nicht kaputtsparen"
        />
      </div>
      <Kontakt />
      <a
        className="landing_venen_cta"
        href="https://bvphlebologie.de/venenkompetenz-zentrum"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="landing_venen_text">
          <h2>Venenkompetenzzentrum</h2>
          <p>Mehr Informationen beim Berufsverband der Phlebologen.</p>
          <span className="landing_venen_button">Zur Website</span>
        </div>
        <img
          src="/Venen%20Kompetenz-Zentrum_Logo.jpg"
          alt="Venen Kompetenz-Zentrum"
        />
      </a>
    </SectionWrapper>
  </div>
);
export default LandingSection;
